var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { set, computed } from '@ember/object';
import { equal, readOnly, or } from '@ember/object/computed';
import { loadFeatures } from '@dashboard/i18n/utils/utils';
import { getCookie, setCookie, removeCookie } from '@square/dashboard-utilities/utils/cookies';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
let UserInfo = (_dec = readOnly('currentUserData.data'), _dec2 = computed('countryCode', '_isCA'), _dec3 = computed('countryCode', '_isUS'), _dec4 = computed('_isJP', 'countryCode'), _dec5 = computed('_isGB', 'countryCode'), _dec6 = computed('countryCode', '_isAU'), _dec7 = computed('countryCode', '_isPT'), _dec8 = equal('countryCode', 'FR'), _dec9 = equal('countryCode', 'PR'), _dec10 = equal('countryCode', 'VI'), _dec11 = equal('countryCode', 'IE'), _dec12 = equal('countryCode', 'ES'), _dec13 = or('isGB', 'isFR', 'isIE', 'isES'), _dec14 = computed('_isEmployee', 'employmentToken'), _dec15 = computed('_isNotEmployee', 'isEmployee'), _dec16 = computed('_subjectFieldsForContext', 'employmentToken', 'merchantToken', 'personToken', 'unitToken'), _dec17 = computed('_countryFeatures', 'countryCode'), _dec18 = computed('wantsDesktopValue'), _dec19 = computed('isTIDALArtistValue'), _class = class UserInfo extends Service {
  get isCA() {
    if (this._isCA !== undefined) {
      return this._isCA;
    }
    return this.countryCode === 'CA';
  }
  set isCA(value) {
    set(this, '_isCA', value);
  }
  get isUS() {
    if (this._isUS !== undefined) {
      return this._isUS;
    }
    return this.countryCode === 'US';
  }
  set isUS(value) {
    set(this, '_isUS', value);
  }
  get isJP() {
    if (this._isJP !== undefined) {
      return this._isJP;
    }
    return this.countryCode === 'JP';
  }
  set isJP(value) {
    set(this, '_isJP', value);
  }
  get isGB() {
    if (this._isGB !== undefined) {
      return this._isGB;
    }
    return this.countryCode === 'GB';
  }
  set isGB(value) {
    set(this, '_isGB', value);
  }
  get isAU() {
    if (this._isAU !== undefined) {
      return this._isAU;
    }
    return this.countryCode === 'AU';
  }
  set isAU(value) {
    set(this, '_isAU', value);
  }
  get isPT() {
    if (this._isPT !== undefined) {
      return this._isPT;
    }
    return this.countryCode === 'PT';
  }
  set isPT(value) {
    set(this, '_isPT', value);
  }
  get isEmployee() {
    if (this._isEmployee !== undefined) {
      return this._isEmployee;
    }
    return Boolean(this.employmentToken);
  }
  set isEmployee(value) {
    set(this, '_isEmployee', value);
  }
  get isNotEmployee() {
    if (this._isNotEmployee !== undefined) {
      return this._isNotEmployee;
    }
    return !this.isEmployee;
  }
  set isNotEmployee(value) {
    set(this, '_isNotEmployee', value);
  }
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUserData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    /* eslint-disable prettier/prettier */
    _defineProperty(this, "token", this.data.token);
    _defineProperty(this, "loggableSessionToken", this.data.loggableSessionToken);
    _defineProperty(this, "name", this.data.name);
    _defineProperty(this, "businessType", this.data.businessType);
    _defineProperty(this, "countryCode", this.data.countryCode);
    _defineProperty(this, "currencyCode", this.data.currencyCode);
    _defineProperty(this, "email", this.data.email);
    _defineProperty(this, "languageCode", this.data.languageCode);
    _defineProperty(this, "parentMerchant", this.data.parentMerchant);
    _defineProperty(this, "merchantProfile", this.data.merchantProfile);
    _defineProperty(this, "mainUnitToken", this.data.mainUnitToken);
    _defineProperty(this, "personToken", this.data.personToken);
    // Do not use this! It will not get updated if they change their subscription status.
    // Use the user-subscriptions service instead.
    _defineProperty(this, "subscriptionFeatureStatus", this.data.subscriptionFeatureStatus);
    _defineProperty(this, "authorizedUnitTokens", this.data.authorizedUnitTokens);
    _defineProperty(this, "merchantToken", this.data.merchantToken);
    _defineProperty(this, "unitToken", this.data.unitToken);
    _defineProperty(this, "employmentToken", this.data.employmentToken);
    _defineProperty(this, "canAccessAllCurrentAndFutureUnits", this.data.canAccessAllCurrentAndFutureUnits);
    _defineProperty(this, "isCbdSeller", this.data.isCbdSeller);
    _defineProperty(this, "restaurantsJoinedAt", this.data.restaurantsJoinedAt);
    _defineProperty(this, "canSeeLoans", this.data.canSeeLoans);
    _defineProperty(this, "impersonating", this.data.impersonating);
    _defineProperty(this, "businessCategory", this.data.mccData?.category ?? null);
    _defineProperty(this, "businessSubcategory", this.data.mccData?.subcategory ?? null);
    _defineProperty(this, "isBlockEmployeeEmail", this.data.isBlockEmployeeEmail ?? false);
    /* eslint-enable prettier/prettier */
    _defineProperty(this, "_isCA", void 0);
    _defineProperty(this, "_isUS", void 0);
    _defineProperty(this, "_isJP", void 0);
    _defineProperty(this, "_isGB", void 0);
    _defineProperty(this, "_isAU", void 0);
    _defineProperty(this, "_isPT", void 0);
    _initializerDefineProperty(this, "isFR", _descriptor3, this);
    _initializerDefineProperty(this, "isPR", _descriptor4, this);
    _initializerDefineProperty(this, "isVI", _descriptor5, this);
    _initializerDefineProperty(this, "isIE", _descriptor6, this);
    _initializerDefineProperty(this, "isES", _descriptor7, this);
    _initializerDefineProperty(this, "isEU", _descriptor8, this);
    // TODO: isEmployee should no longer be necessary, since unit login should no longer exist, remove once all usages are removed
    _defineProperty(this, "_isEmployee", void 0);
    _defineProperty(this, "_isNotEmployee", void 0);
    _defineProperty(this, "browserLanguage", void 0);
    /**
     * Provides an easy way to get all (currently) untracked subject fields that
     * should be passed in the `context` of CDP Data API calls. These are required
     * fields in the Ecosystem Engagement (EEN) Dashboard Instrumentation Framework.
     */
    _defineProperty(this, "_subjectFieldsForContext", void 0);
    _defineProperty(this, "_countryFeatures", void 0);
    _defineProperty(this, "wantsDesktopValue", false);
    _defineProperty(this, "isTIDALArtistValue", false);
    const rawLang = document.documentElement?.lang || 'en';

    // TODO: figure out why html.lang becomes lowercased after the app initializes and replace this transform
    const [lang, country] = rawLang.split('-');
    if (country) {
      this.browserLanguage = `${lang}-${country.toUpperCase()}`;
    } else {
      this.browserLanguage = lang;
    }
  }
  get subjectFieldsForContext() {
    if (this._subjectFieldsForContext !== undefined) {
      return this._subjectFieldsForContext;
    }
    return {
      subject: {
        employmentToken: this.employmentToken,
        merchantToken: this.merchantToken,
        personToken: this.personToken,
        unitToken: this.unitToken
      }
    };
  }
  set subjectFieldsForContext(value) {
    set(this, '_subjectFieldsForContext', value);
  }
  get countryFeatures() {
    if (this._countryFeatures !== undefined) {
      return this._countryFeatures;
    }
    return loadFeatures(this.countryCode);
  }
  set countryFeatures(value) {
    set(this, '_countryFeatures', value);
  }
  get wantsDesktop() {
    if (getCookie('nav-dt') === '1') {
      return true;
    }
    return this.wantsDesktopValue;
  }
  set wantsDesktop(value) {
    if (value) {
      setCookie('nav-dt', '1', OneTrustConsent.FUNCTIONAL);
    } else {
      removeCookie('nav-dt');
    }
    set(this, 'wantsDesktopValue', value);
  }
  get isTIDALArtist() {
    if (getCookie('tidal_artist_mode') === '1') {
      return true;
    }
    return this.isTIDALArtistValue;
  }
  set isTIDALArtist(value) {
    if (value) {
      setCookie('tidal_artist_mode', '1', OneTrustConsent.FUNCTIONAL);
    } else {
      removeCookie('tidal_artist_mode');
    }
    set(this, 'isTIDALArtistValue', value);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isCA", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "isCA"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUS", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "isUS"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isJP", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "isJP"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGB", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "isGB"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAU", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "isAU"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPT", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "isPT"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isFR", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isPR", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isVI", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isIE", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isES", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isEU", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isEmployee", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "isEmployee"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNotEmployee", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "isNotEmployee"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subjectFieldsForContext", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "subjectFieldsForContext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "countryFeatures", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "countryFeatures"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wantsDesktop", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "wantsDesktop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTIDALArtist", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "isTIDALArtist"), _class.prototype), _class);
export { UserInfo as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.